import {
  ComcastErrorType,
  triggerSentryError,
} from '../../../../shared/helpers'
import { updateWatchHistory } from '../../actions/contentActions'

export async function resetWatchHistory(videoId: string): Promise<void> {
  try {
    await updateWatchHistory(videoId, 0)
  } catch (error) {
    triggerSentryError('updateWatchHistory', 'VideoPlaybackScreen.js', {
      errorMessage: error.message ?? 'Undefined error message (default)',
      videoId: videoId,
      secondsWatched: 0,
      errorLocation: 'VideoPlaybackScreen - updateWatchHistory',
      errorType: ComcastErrorType.other,
    })
  }
}

export function getInitialPlayheadPosition(
  seconds_watched: number,
  duration: number
): number {
  let playheadPosition = seconds_watched
  if (seconds_watched < 30 || seconds_watched > duration * 0.95) {
    playheadPosition = 0
  }
  return playheadPosition
}
